import { Controller } from "@hotwired/stimulus"

// Phase Grouping Controller for Mode A sequential planning
// Manages adding/removing phases and ensuring shifts are only in one phase
export default class extends Controller {
  static targets = ["phaseList", "phase", "phaseSelect"]

  connect() {
    this.maxPhases = 4
    this.visiblePhases = this.phaseTargets.filter(p => p.style.display !== "none").length
  }

  addPhase() {
    if (this.visiblePhases >= this.maxPhases) return

    const nextPhase = this.phaseTargets.find(p => p.style.display === "none")
    if (nextPhase) {
      nextPhase.style.display = ""
      this.visiblePhases++
    }
  }

  removePhase(event) {
    const phaseNum = event.currentTarget.dataset.phase
    const phaseEl = this.phaseTargets.find(p => p.dataset.phase === phaseNum)
    if (phaseEl) {
      // Clear selections
      const select = phaseEl.querySelector("select")
      if (select) {
        Array.from(select.options).forEach(opt => opt.selected = false)
      }
      phaseEl.style.display = "none"
      this.visiblePhases--
    }
  }

  updatePhases() {
    // Optional: validate that shifts aren't in multiple phases
    const selectedByPhase = {}
    this.phaseSelectTargets.forEach((select, idx) => {
      if (select.closest("[data-phase]").style.display === "none") return
      const phase = select.closest("[data-phase]").dataset.phase
      selectedByPhase[phase] = Array.from(select.selectedOptions).map(o => o.value)
    })

    // Highlight duplicates
    const allSelected = Object.values(selectedByPhase).flat()
    const duplicates = allSelected.filter((v, i) => allSelected.indexOf(v) !== i)

    this.phaseSelectTargets.forEach(select => {
      Array.from(select.options).forEach(opt => {
        if (duplicates.includes(opt.value) && opt.selected) {
          opt.style.backgroundColor = "#fef2f2"
        } else {
          opt.style.backgroundColor = ""
        }
      })
    })
  }
}
